export const apiBaseUrl = 'https://api.garance-a-vos-cotes.fr'
export const vueBaseUrl = 'https://app.garance-a-vos-cotes.fr'

